import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Routes } from '../../config/routes';
import { ApplicationHttpClient } from '../../components/shared/http/application-http-client';
import { AvailableFeatureFlag } from '../../models/entities/available-feature-flag';
import { FeatureFlag } from '../../models/entities/feature-flag';

export type FeatureFlagContext = 'organization' | 'pmc';

@Injectable({
    providedIn: 'root',
})
export class FeatureFlagsService
{
    constructor(
            private _http: ApplicationHttpClient,
    ) {
    }

    public getAvailableFeatureFlags(context: FeatureFlagContext): Observable<AvailableFeatureFlag[]> {
        const url: string = Routes.MakeLegFiCoreUrl(Routes.CoreV2Module.AvailableFeatureFlags(context));
        return this._http.get(url).pipe(map((response: Object[]) => {
            return response.map((widget) => {
                return new AvailableFeatureFlag(widget);
            });
        }));
    }

    public getFeatureFlags(context: FeatureFlagContext, orgId: number): Observable<FeatureFlag[]> {
        const url: string = Routes.MakeLegFiCoreUrl(Routes.CoreV2Module.FeatureFlags(context, orgId));
        return this._http.get(url).pipe(map((response: Object[]) => {
            return response.map((widget) => {
                return new FeatureFlag(widget);
            });
        }));
    }

    public createFeatureFlag(context: FeatureFlagContext, orgId: number, flagName: string): Observable<FeatureFlag> {
        const url: string = Routes.MakeLegFiCoreUrl(Routes.CoreV2Module.FeatureFlags(context, orgId));
        return this._http.post(url, JSON.stringify({featureName: flagName})).pipe(map((response: Object) => {
            return new FeatureFlag(response);
        }));
    }

    public deleteFeatureFlag(context: FeatureFlagContext, orgId: number, flagName: string): Observable<Object> {
        const url: string = Routes.MakeLegFiCoreUrl(Routes.CoreV2Module.FeatureFlags(context, orgId)) + '/' + flagName;
        return this._http.delete(url);
    }
}
